/**
 * @param {number} bytes
 */
export function formatBytes(bytes) {
  if (!+bytes) return "0 Bytes";

  const kByte = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(kByte));

  return `${parseFloat((bytes / Math.pow(kByte, i)).toFixed(2))} ${sizes[i]}`;
}

/**
 * @param {number} value
 */
export function formatNumber(value) {
  if (typeof value !== "number") return 0;

  const formatter = new Intl.NumberFormat("pt-BR");

  return formatter.format(value);
}
